import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

var _dec, _dec2, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Link } from '@instructure/ui-link';
import { omitProps, deprecated } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
/**
---
parent: Breadcrumb
id: Breadcrumb.Link
---
**/

var BreadcrumbLink = (_dec = testable(), _dec2 = deprecated('8.0.0', {
  icon: 'renderIcon'
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(BreadcrumbLink, _Component);

  var _super = _createSuper(BreadcrumbLink);

  function BreadcrumbLink() {
    _classCallCheck(this, BreadcrumbLink);

    return _super.apply(this, arguments);
  }

  _createClass(BreadcrumbLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          renderIcon = _this$props.renderIcon,
          iconPlacement = _this$props.iconPlacement,
          onClick = _this$props.onClick,
          icon = _this$props.icon;
      var props = omitProps(this.props, BreadcrumbLink.propTypes);
      return /*#__PURE__*/React.createElement(Link, Object.assign({
        as: this.element
      }, props, {
        href: href,
        renderIcon: renderIcon || icon,
        iconPlacement: iconPlacement,
        onClick: onClick,
        isWithinText: false
      }), /*#__PURE__*/React.createElement(TruncateText, null, children));
    }
  }]);

  BreadcrumbLink.displayName = "BreadcrumbLink";
  return BreadcrumbLink;
}(Component), _class2.propTypes = {
  /**
  * Content to render as the crumb, generally should be text.
  */
  children: PropTypes.node.isRequired,

  /**
  * Link the crumb should direct to; if an href is provided, the crumb will render as a link
  */
  href: PropTypes.string,

  /**
  * If the Breadcrumb.Link has an onClick prop (and no href), it will render as a button
  */
  onClick: PropTypes.func,

  /**
  * Sets the font-size of the breadcrumb text
  */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Add an icon to the Breadcrumb.Link
   */
  renderIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),

  /**
  * __Deprecated - use `renderIcon` instead
  */
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),

  /**
  * Place the icon before or after the text in the Breadcrumb.Link
  */
  iconPlacement: PropTypes.oneOf(['start', 'end'])
}, _class2.defaultProps = {
  href: void 0,
  onClick: void 0,
  size: void 0,
  renderIcon: void 0,
  icon: void 0,
  iconPlacement: void 0
}, _temp)) || _class) || _class);
export default BreadcrumbLink;
export { BreadcrumbLink };